/* VIMZO CREATIONS – product page
   Gallery (swipe, thumbnails, zoom) + colour/variant selection that keeps
   image, swatch, label, Shopify variant, URL and the Customize link in sync. */
(function () {
  'use strict';

  var STORE_KEY = 'vimzo:customizer';
  var RETURN_KEY = 'vimzo:return-to-product';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slugify(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/['"’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
  function readStore() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function writeStore(patch) {
    try {
      var s = readStore();
      Object.keys(patch).forEach(function (k) { s[k] = patch[k]; });
      localStorage.setItem(STORE_KEY, JSON.stringify(s));
    } catch (e) { /* storage unavailable */ }
  }

  /* ---------- Gallery ---------- */
  function Gallery(el, onUserSelect) {
    var track = el.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(el.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(el.querySelectorAll('[data-gallery-thumb]'));
    var dots = Array.prototype.slice.call(el.querySelectorAll('.gallery__dot'));
    var active = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    var programmatic = false;
    var scrollTimer;

    function setActive(i) {
      active = i;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === i);
        s.setAttribute('aria-hidden', n === i ? 'false' : 'true');
      });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }

    function goTo(i, behavior) {
      if (i < 0 || i >= slides.length) return;
      programmatic = true;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : (behavior || 'smooth') });
      setActive(i);
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { programmatic = false; }, 600);
      // Fallback: if smooth scrolling was interrupted (or the tab is hidden), snap to the slide
      setTimeout(function () {
        if (active === i && Math.abs(track.scrollLeft - i * track.clientWidth) > 2) {
          programmatic = true;
          track.scrollTo({ left: i * track.clientWidth, behavior: 'auto' });
        }
      }, 700);
    }

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (programmatic) { programmatic = false; return; }
        if (i !== active) {
          setActive(i);
          onUserSelect(slides[i], i);
        }
      }, 90);
    }, { passive: true });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-gallery-thumb'), 10);
        goTo(i);
        onUserSelect(slides[i], i);
      });
    });
    var prev = el.querySelector('[data-gallery-prev]');
    var next = el.querySelector('[data-gallery-next]');
    function step(d) {
      var i = (active + d + slides.length) % slides.length;
      goTo(i);
      onUserSelect(slides[i], i);
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });

    // Hover zoom (desktop, fine pointer only)
    if (el.hasAttribute('data-zoom-enabled')) {
      var canHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
      el.querySelectorAll('[data-zoom-frame]').forEach(function (frame) {
        frame.addEventListener('mouseenter', function () { if (canHover.matches) frame.classList.add('is-zooming'); });
        frame.addEventListener('mouseleave', function () { frame.classList.remove('is-zooming'); });
        frame.addEventListener('mousemove', function (e) {
          if (!canHover.matches) return;
          var r = frame.getBoundingClientRect();
          frame.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          frame.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        });
      });
    }

    window.addEventListener('resize', function () {
      track.scrollTo({ left: active * track.clientWidth, behavior: 'auto' });
    });

    return {
      slides: slides,
      goTo: goTo,
      get active() { return active; }
    };
  }

  /* ---------- Product ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var variants = data.variants || [];
    var colourIndex = (data.options || []).findIndex(function (o) { return /^colou?r$/i.test(o); });
    if (colourIndex < 0) colourIndex = 0;

    var input = root.querySelector('[data-variant-input]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-group]'));
    var priceEl = root.querySelector('[data-price-current]');
    var compareEl = root.querySelector('[data-price-compare]');
    var addBtn = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var customizeLink = root.querySelector('[data-customize-link]');
    var galleryEl = root.querySelector('[data-gallery]');
    var current = variants.find(function (v) { return String(v.id) === String(input && input.value); }) || variants[0];

    var gallery = galleryEl ? Gallery(galleryEl, function (slide) {
      // Swiping or clicking a thumbnail of another colour selects that colour
      var slug = slide.getAttribute('data-colour');
      var mediaId = slide.getAttribute('data-media-id');
      var match = variants.find(function (v) { return v.featured_media && String(v.featured_media.id) === mediaId; });
      if (!match && slug) {
        match = variants.find(function (v) {
          return slugify(v.options[colourIndex]) === slug &&
            v.options.every(function (o, i) { return i === colourIndex || o === current.options[i]; });
        });
      }
      if (match && match.id !== current.id) setVariant(match, { scrollGallery: false });
    }) : null;

    function variantFromInputs() {
      var opts = groups.map(function (g) {
        var checked = g.querySelector('[data-option-input]:checked');
        return checked ? checked.value : null;
      });
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === null || o === opts[i]; });
      });
    }

    function slideIndexFor(variant) {
      if (!gallery) return -1;
      var idx = -1;
      if (variant.featured_media) {
        idx = gallery.slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(variant.featured_media.id); });
      }
      if (idx < 0) {
        var slug = slugify(variant.options[colourIndex]);
        idx = gallery.slides.findIndex(function (s) { return s.getAttribute('data-colour') === slug; });
      }
      return idx;
    }

    function setUnavailable(label) {
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = label;
      if (customizeLink) customizeLink.setAttribute('aria-disabled', 'true');
    }

    function setVariant(variant, opts) {
      opts = opts || {};
      if (!variant) { setUnavailable(window.VIMZO.strings.unavailable); return; }
      current = variant;

      // Radios + labels
      groups.forEach(function (g, i) {
        var value = variant.options[i];
        g.querySelectorAll('[data-option-input]').forEach(function (r) { r.checked = r.value === value; });
        var lbl = g.querySelector('[data-option-label]');
        if (lbl) lbl.textContent = value;
      });

      if (input) input.value = variant.id;

      // Price
      if (priceEl) priceEl.textContent = window.VIMZO.formatMoney(variant.price);
      if (compareEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = window.VIMZO.formatMoney(variant.compare_at_price);
      }

      // Availability
      if (variant.available) {
        if (addBtn) addBtn.disabled = false;
        if (addLabel && addBtn) addLabel.textContent = addBtn.getAttribute('data-label');
        if (customizeLink) customizeLink.removeAttribute('aria-disabled');
      } else {
        setUnavailable(window.VIMZO.strings.soldOut);
      }

      // Customize link keeps variant + colour
      var slug = slugify(variant.options[colourIndex]);
      if (customizeLink) {
        customizeLink.href = (data.customizerUrl || '/pages/customize') + '?variant=' + variant.id + '&color=' + slug;
      }

      // Gallery
      if (gallery && opts.scrollGallery !== false) {
        var idx = slideIndexFor(variant);
        if (idx > -1) gallery.goTo(idx, opts.instant ? 'auto' : 'smooth');
      }

      // You May Also Like: hide the colour already selected
      document.querySelectorAll('[data-ymal-item]').forEach(function (li) {
        li.hidden = li.getAttribute('data-ymal-item') === String(variant.id);
      });

      // URL
      if (opts.updateUrl !== false && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        url.searchParams.delete('color');
        history.replaceState({}, '', url.toString());
      }

      writeStore({ productId: data.id, variantId: variant.id });
      root.dispatchEvent(new CustomEvent('vimzo:variant-change', { detail: variant, bubbles: true }));
    }

    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-input]')) return;
      setVariant(variantFromInputs());
    });

    if (customizeLink) {
      customizeLink.addEventListener('click', function (e) {
        if (customizeLink.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
        try { sessionStorage.setItem(RETURN_KEY, String(data.id)); } catch (err) { /* ignore */ }
        writeStore({ productId: data.id, variantId: current.id });
      });
    }

    // Returning from the customizer: use the colour chosen there
    function variantFromCustomizer() {
      var flag;
      try { flag = sessionStorage.getItem(RETURN_KEY); } catch (e) { flag = null; }
      if (flag !== String(data.id)) return null;
      try { sessionStorage.removeItem(RETURN_KEY); } catch (e) { /* ignore */ }
      var s = readStore();
      return variants.find(function (v) { return String(v.id) === String(s.variantId); }) || null;
    }

    function initialVariant() {
      var params = new URLSearchParams(window.location.search);
      var fromCustomizer = variantFromCustomizer();
      if (fromCustomizer) return fromCustomizer;
      if (!params.get('variant') && params.get('color')) {
        var slug = slugify(params.get('color'));
        var byColour = variants.find(function (v) { return slugify(v.options[colourIndex]) === slug && v.available; }) ||
          variants.find(function (v) { return slugify(v.options[colourIndex]) === slug; });
        if (byColour) return byColour;
      }
      return current;
    }

    var start = initialVariant();
    var params = new URLSearchParams(window.location.search);
    setVariant(start, { instant: true, updateUrl: start.id !== current.id || params.has('color') || params.has('variant') });

    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var v = variantFromCustomizer();
      if (v) setVariant(v, { instant: true });
    });

    // Theme editor: re-run after this section is re-rendered
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('[data-product]')) window.location.reload();
    });
  });
})();
